/* Mission Beard — Shop All page.
   Category chips, scent chips (multi-select) and sort. Cards are server-rendered
   in their category groups; this only moves, hides and re-orders them.
   - "All" + "Featured": grouped view (the server-rendered layout).
   - Anything else: one flat grid in the chosen order.
   State is mirrored to ?type=&scent=&sort= so filtered views can be shared.
   "+ Add" is handled by mb-plp.js ([data-mb-plp-add]). */
(function () {
  'use strict';
  if (window.__mbShopInit) return;
  window.__mbShopInit = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var root = document.querySelector('[data-mb-shop]');
    if (!root) return;

    var bar = root.querySelector('[data-shop-bar]');
    var catBtns = [].slice.call(root.querySelectorAll('[data-shop-cat]'));
    var scentBtns = [].slice.call(root.querySelectorAll('[data-shop-scent]'));
    var sortSel = root.querySelector('[data-shop-sort]');
    var groups = [].slice.call(root.querySelectorAll('[data-shop-group]'));
    var flat = root.querySelector('[data-shop-flat]');
    var empty = root.querySelector('[data-shop-empty]');
    var emptyNote = root.querySelector('[data-shop-empty-note]');
    var cards = [].slice.call(root.querySelectorAll('[data-shop-card]'));
    var catOrder = groups.map(function (g) { return g.getAttribute('data-shop-group'); });

    var state = { cat: 'all', scents: [], sort: 'featured' };

    cards.forEach(function (c) {
      var s = c.getAttribute('data-scents');
      c._scents = s ? s.split('|') : [];
      c._cat = c.getAttribute('data-cat');
      c._rank = +c.getAttribute('data-rank');
      c._price = +c.getAttribute('data-price');
      c._rating = +c.getAttribute('data-rating') || 0;
      c._reviews = +c.getAttribute('data-reviews') || 0;
      c._home = root.querySelector('[data-shop-group="' + c._cat + '"] [data-shop-grid]');
    });

    /* Keep the bar just under the sticky header. */
    function setTop() {
      var header = document.querySelector('.mb-header');
      var sec = header && header.closest('.shopify-section');
      var top = 0;
      if (sec && getComputedStyle(sec).position === 'sticky') top = sec.getBoundingClientRect().height;
      root.style.setProperty('--mb-shop-top', Math.round(top) + 'px');
    }

    function scentOk(c) {
      if (!state.scents.length || !c._scents.length) return true; // no scent variants = sold in all
      return c._scents.some(function (s) { return state.scents.indexOf(s) > -1; });
    }

    var sorters = {
      featured: function (a, b) { return (catOrder.indexOf(a._cat) - catOrder.indexOf(b._cat)) || (a._rank - b._rank); },
      rating: function (a, b) { return (b._rating - a._rating) || (b._reviews - a._reviews); },
      low: function (a, b) { return a._price - b._price; },
      high: function (a, b) { return b._price - a._price; }
    };

    function render() {
      var pool = cards.filter(scentOk);

      catBtns.forEach(function (b) {
        var id = b.getAttribute('data-shop-cat');
        b.setAttribute('aria-pressed', id === state.cat ? 'true' : 'false');
        var n = id === 'all' ? pool.length : pool.filter(function (c) { return c._cat === id; }).length;
        var span = b.querySelector('[data-shop-count]');
        if (span) span.textContent = n;
      });
      scentBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', state.scents.indexOf(b.getAttribute('data-shop-scent')) > -1 ? 'true' : 'false');
      });
      if (sortSel.value !== state.sort) sortSel.value = state.sort;

      var inCat = pool.filter(function (c) { return state.cat === 'all' || c._cat === state.cat; });
      var grouped = state.cat === 'all' && state.sort === 'featured';

      cards.forEach(function (c) { c.hidden = inCat.indexOf(c) === -1; });

      if (grouped) {
        cards.slice().sort(sorters.featured).forEach(function (c) { c._home.appendChild(c); });
        groups.forEach(function (g) {
          var id = g.getAttribute('data-shop-group');
          g.hidden = !inCat.some(function (c) { return c._cat === id; });
        });
        flat.hidden = true;
      } else {
        inCat.sort(sorters[state.sort]).forEach(function (c) { flat.appendChild(c); });
        groups.forEach(function (g) { g.hidden = true; });
        flat.hidden = !inCat.length;
      }

      empty.hidden = inCat.length > 0;
      if (!inCat.length) {
        var catBtn = catBtns.filter(function (b) { return b.getAttribute('data-shop-cat') === state.cat; })[0];
        var label = (catBtn && catBtn.getAttribute('data-label')) || 'That range';
        var or = ' ' + (emptyNote.getAttribute('data-or') || 'or') + ' ';
        emptyNote.textContent = emptyNote.getAttribute('data-template')
          .replace('[category]', label)
          .replace('[scents]', state.scents.join(or));
      }

      var q = new URLSearchParams(window.location.search);
      if (state.cat !== 'all') q.set('type', state.cat); else q.delete('type');
      if (state.scents.length) q.set('scent', state.scents.join(',')); else q.delete('scent');
      if (state.sort !== 'featured') q.set('sort', state.sort); else q.delete('sort');
      var qs = q.toString();
      history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
    }

    function scrollToResults() {
      var y = root.querySelector('.mb-shop__results').getBoundingClientRect().top + window.scrollY - bar.getBoundingClientRect().height - (parseInt(getComputedStyle(root).getPropertyValue('--mb-shop-top'), 10) || 0);
      if (window.scrollY > y) window.scrollTo({ top: y, behavior: 'smooth' });
    }

    catBtns.forEach(function (b) {
      b.addEventListener('click', function () { state.cat = b.getAttribute('data-shop-cat'); render(); scrollToResults(); });
    });
    scentBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var n = b.getAttribute('data-shop-scent'), i = state.scents.indexOf(n);
        if (i > -1) state.scents.splice(i, 1); else state.scents.push(n);
        render(); scrollToResults();
      });
    });
    sortSel.addEventListener('change', function () { state.sort = sortSel.value; render(); scrollToResults(); });
    root.querySelector('[data-shop-clear]').addEventListener('click', function () { state.cat = 'all'; state.scents = []; render(); });

    /* Restore a shared/filtered URL. */
    var q = new URLSearchParams(window.location.search);
    if (q.get('type') && catBtns.some(function (b) { return b.getAttribute('data-shop-cat') === q.get('type'); })) state.cat = q.get('type');
    if (q.get('scent')) state.scents = q.get('scent').split(',').filter(function (s) { return scentBtns.some(function (b) { return b.getAttribute('data-shop-scent') === s; }); });
    if (sorters[q.get('sort')]) state.sort = q.get('sort');

    setTop();
    window.addEventListener('resize', setTop);
    if (state.cat !== 'all' || state.scents.length || state.sort !== 'featured') render();
  });
})();
